import { ROUTES, TITLES, PROD, STAGE, DEV } from 'consts';

export const PLACEMENTS_STATUS_MENU = {
  key: ROUTES.PLACEMENTS_STATUS.ROOT,
  label: TITLES[ROUTES.PLACEMENTS_STATUS.ROOT],
  environment: [DEV, STAGE, PROD],
};
